import { useEffect } from 'react';

import { disableScrolling } from 'bundles/browse-common/legacy/utils/disableScrolling';
import { useIsMobileHeader } from 'bundles/search-common/components/searchbar/hero/useIsMobileHeader';

export const useDisableScrollOnMobile = (isSearchBarFocused: boolean) => {
  const isMobileHeader = useIsMobileHeader();

  useEffect(() => {
    if (!isMobileHeader) {
      return;
    }

    disableScrolling(isSearchBarFocused);
  }, [isSearchBarFocused, isMobileHeader]);
};
